<script>
import CandelaComponent from '@/components/CandelaComponent'
import {heatmap} from '@/components/plots/atoms'

export default {
  computed: {
    heatmap() {
      return heatmap(this.x, this.y, this.axis_x, this.axis_y)
    },
    legend_state() {
      return {
        id: this.id + '-legend',
        x: this.y,
        frame: this.frame,
        settings: {
          spectrum: this.settings.spectrum
        }
      }
    }
  },
  data() {
    return {
      axis_x: null,
      axis_y: null
    }
  },
  extends: CandelaComponent,
  name: 'Heatmap',
  methods: {
    update(axes) {
      this.axis_x = axes.x
      this.axis_y = axes.y
    }
  },
  props: {
    x: {type: Object, default: () => ({})},
    y: {type: Object, default: () => ({})}
  }
}
</script>

<template>
<div :id='`${id}-heatmap`' class='candela-component
  flex-row flex-justify-stretch flex-nowrap'>
  <div class='d-flex flex-grow-1'>
    <candela-plot ref='plot' :id='id' :frame='frame'
      @update='update' :bound_rect_visible='false'>
      <candela-axis slot='axis_y' v-bind='y' :padding='0'
        scale_type='band' reversed/>
      <candela-axis slot='axis_x' v-bind='x' :padding='0'
        scale_type='band'/>
      <div slot='html-content'>
        <div v-for='(c, i) in heatmap' :key='`rect-${i}`'
          class='cell d-flex align-center justify-center' :style='{
            left: `${c.x}px`,
            top: `${c.y}px`,
            width: `${c.w}px`,
            height: `${c.h}px`,
            backgroundColor: settings.spectrum.value(c.o)
          }'>
          <span class='label px-1 font-weight-bold'>{{c.v}}</span>
        </div>
      </div>
    </candela-plot>
  </div>
  <div class='d-flex flex-shrink-1 mb-11'>
    <candela-gradient-legend v-bind='legend_state' :frame='frame'/>
  </div>
</div>
</template>

<style lang='sass' scoped>
.cell
  position: absolute

.label
  color: white
  font-size: 0.80rem !important
  position: absolute
  text-align: center
  mix-blend-mode: difference

</style>
